import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import InputField from '../../../form/InputField';
import CheckboxField from '../../../form/CheckboxField';

const ReceiptsTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.receiptConfig')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-4">
                            <CheckboxField
                                label={t('admin.showCustomerInfo')}
                                checked={settings.receipts.show_customer_info}
                                onChange={(e) => handleChange('receipts', 'show_customer_info', e.target.checked)}
                            />
                            <CheckboxField
                                label={t('admin.showOrderNumber')}
                                checked={settings.receipts.show_order_number}
                                onChange={(e) => handleChange('receipts', 'show_order_number', e.target.checked)}
                            />
                            <CheckboxField
                                label={t('admin.showQrCode')}
                                checked={settings.receipts.qr_code}
                                onChange={(e) => handleChange('receipts', 'qr_code', e.target.checked)}
                            />
                        </div>
                        <div className="space-y-6">
                            <InputField
                                label={t('admin.footerText')}
                                value={settings.receipts.footer_text}
                                onChange={(e) => handleChange('receipts', 'footer_text', e.target.value)}
                                type="textarea"
                            />
                            <InputField
                                label={t('admin.footerTextAr')}
                                value={settings.receipts.footer_text_ar}
                                onChange={(e) => handleChange('receipts', 'footer_text_ar', e.target.value)}
                                type="textarea"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReceiptsTab;
